import { useQuery } from "@tanstack/react-query";
import { getPendingPayment } from "../services/pendingPaymentService";

export const usePendingPayment = (token?: string | null) => {
  return useQuery({
    queryKey: ["pending-payment"],
    queryFn: () => getPendingPayment(token as string),
    enabled: !!token,
    staleTime: 0,
    retry: false,
    refetchInterval: 15000,
    refetchOnWindowFocus: true,
  });
};
